import { Immutable } from "@hookstate/core";
import { forwardRef, useMemo } from "react";
import { FilterTagButton } from "../../../../components/buttons/FilterTag";
import { GlobalIcon } from "../../../../components/icons/GlobalIcon";
import { CountryEntity } from "../../../../services/gc/types";
import { Option } from "../../../../types";
import { FacetGroupFilter } from "./FacetGroupFilter";
import { FilterTitle } from "../../../../components/filters/FilterTitle";
interface CountryFacetGroupFilterProps {
  value: Immutable<string[] | undefined>;
  countries: CountryEntity[];
  onChange: (nextValue: string[]) => void;
  tinted?: boolean;
}
export function CountryFacetGroupFilter({
  value,
  countries,
  onChange,
  tinted,
}: CountryFacetGroupFilterProps) {
  const countryOptions: Option<string>[] = useMemo(
    () => [
      ...countries.map((type) => ({
        label: type.name,
        value: "" + type.id,
      })),
    ],
    [],
  );

  return (
    <FacetGroupFilter
      value={value}
      options={countryOptions}
      onChange={onChange}
      tinted={tinted}
    />
  );
}

interface CountryFacetGroupFilterTitleProps {
  isTrigger: boolean;
  countries: CountryEntity[];
  activeValue?: Immutable<string[] | undefined>;
  open?: boolean;
}
export const CountryFacetGroupFilterTitle = forwardRef(
  (
    { isTrigger, countries, activeValue, open, ...props }: CountryFacetGroupFilterTitleProps,
    ref,
  ) => {
    const countryState = activeValue;
    if (isTrigger) {
      return (
        <FilterTagButton
          icon={<GlobalIcon />}
          popoverRef={ref}
          text="Country"
          activeFilters={countryState?.length}
          isFiltering={(countryState?.length ?? 0) > 0}
          {...props}
        />
      );
    }
    return (
      <FilterTitle
        text="Country"
        activeFilters={countryState?.length ?? 0}
        open={open}
        icon={<GlobalIcon boxSize="24px" color="neutral.400" />}
      />
    );
  },
);
